export { default as AppLayout } from './App';
export { default as SecuredLayout } from './Secured';
export { default as ErrorLayout } from './Error';
export { default as PublicLayout } from './Public';



// WEBPACK FOOTER //
// ./layouts/index.js